export const IDLE_LOGOUT_REASON = 'idle' as const

export type IdleLogoutState = { reason: typeof IDLE_LOGOUT_REASON }

export const isIdleLogoutState = (state: unknown): state is IdleLogoutState =>
  typeof state === 'object' &&
  state !== null &&
  'reason' in state &&
  state.reason === IDLE_LOGOUT_REASON
